import React from "react";
import { setHideNavBar } from "../../core/redux/authSlice";
import { useAppDispatch } from "../../core/redux/hooks";
import { useSearchParams , useParams } from "react-router-dom";
import { getRecordingInfo } from "../../core/services/sharedService";
import rcmlogo from "../../assets/rcmlogo.png";


const VoiceMailRecording = () => {
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
    const callSid = searchParams.get("callSid");
    const [mediaUrl, setMediaUrl] = React.useState<any>();

    React.useEffect(() => {
        dispatch(setHideNavBar(true));
           getCallRecordings(callSid);
    }, []);

    const getCallRecordings = React.useCallback(async (callSid:any , isDownload = false) => {
       const res = await getRecordingInfo(callSid);
        if (res && res.data && res.data.mediaUrl) {
               if (!isDownload) {
                setMediaUrl(res.data.mediaUrl);
               } else {
                   window.open( res.data.mediaUrl, '_blank');
               }                   
           }
   }, [])

    return (
        <div className="col-12">
            <div className="row p-2">
                <div className="h-100 d-flex align-items-center justify-content-center">
                    <img
                        src={rcmlogo}
                        alt="Card image"
                        className="rcmlogo"
                    />
                </div>
            </div>
            <div className="border">
                <div className="row p-3">
                    <div className="h-100 d-flex align-items-center justify-content-center">
                        <h2>Recording Information</h2>
                    </div>
                </div>

                <div className="row p-2">
                    <div className="h-100 d-flex align-items-center justify-content-center">
                        <audio controls  src={mediaUrl}></audio>
                    </div>
                </div>

                <div className="row p-2">
                    <div className="h-100 d-flex align-items-center justify-content-center">
                        <button className="btn app-button-color">
                        <a className="app-button-text-color app-text-decoration-none"
                            target="_blank" href={mediaUrl} download="video" > 
                            Download
                        </a>
                    </button>
                    </div>
                </div>
            </div>
        </div>  
    )
}

export default VoiceMailRecording;